import { GridColDef } from "@mui/x-data-grid";
import dayjs from "dayjs";

import ActionsCell from "./ActionsCell";
import { Status } from "./Status";
import DataGridTextHeader from "../../molecules/DataGridTextHeader";

export const customerColumns: GridColDef[] = [
  {
    field: "omneId",
    headerName: "Omne ID",
    width: 350,
    sortable: false,
    disableColumnMenu: true,
  },
  {
    field: "signupCountry",
    headerName: "Signup country",
    width: 90,
    sortable: false,
    disableColumnMenu: true,
    renderHeader: DataGridTextHeader,
  },
  {
    field: "accountCreationDate",
    headerName: "Account Creation date",
    width: 150,
    disableColumnMenu: true,
    renderHeader: DataGridTextHeader,
  },
  {
    field: "omneName",
    headerName: "OMNE name",
    width: 235,
    sortable: false,
    disableColumnMenu: true,
  },
  {
    field: "registration",
    headerName: "Omne Registration Phone/Email",
    width: 248,
    sortable: false,
    disableColumnMenu: true,
    renderCell: item =>
      item.row.primaryLoginAttribute === "Email"
        ? item.row.email
        : item.row.phoneNumber,
  },
  {
    field: "dob",
    headerName: "DOB",
    width: 108,
    sortable: false,
    disableColumnMenu: true,
  },
  {
    field: "insuranceLinkedDate",
    headerName: "Insurance linked date",
    width: 130,
    disableColumnMenu: true,
    renderHeader: DataGridTextHeader,
    valueGetter: ({ value }) => value && dayjs(value).format("DD/MM/YYYY"),
  },
  {
    field: "accountStatus",
    headerName: "Status",
    width: 117,
    sortable: false,
    disableColumnMenu: true,
    headerAlign: "center",
    renderCell: item => Status(item.row?.accountStatus),
  },
  {
    field: "action",
    headerName: "",
    width: 400,
    valueGetter: item => ({
      insuranceLinkedDate: item.row?.insuranceLinkedDate,
      omneId: item.row?.omneId,
      omneName: item.row?.omneName,
      accountStatus: item.row?.accountStatus,
    }),
    sortable: false,
    disableColumnMenu: true,
    headerAlign: "center",
    renderCell: ActionsCell,
  },
];
